import type { GameProvider } from '@/features/games/api.js';
import { providerBadgeCodeOf } from '@/features/games/brandBadge.js';
import { ProviderArt } from './ProviderArt.js';

interface ProviderGridProps {
  providers: GameProvider[];
  onSelect: (id: string) => void;
}

/** Every active camp as a 3:4 art card, wrapped into a grid; the full list behind the row's view-all button. */
export function ProviderGrid({ providers, onSelect }: ProviderGridProps) {
  return (
    <ul className="grid grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-3">
      {providers.map((p) => (
        <li key={p.id}>
          <button
            type="button"
            onClick={() => onSelect(p.id)}
            title={p.displayName}
            className="group block w-full rounded-2xl text-left outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--bg)] focus-visible:ring-[var(--primary)]"
          >
            <ProviderArt
              name={p.displayName}
              logoUrl={p.logoUrl}
              brandColor={p.brandColor}
              badgeCode={providerBadgeCodeOf(p.code)}
              nameClassName="text-[15px] md:text-lg"
              className="aspect-[3/4] w-full rounded-2xl ring-1 ring-[var(--border-strong)] transition-[transform,box-shadow] duration-200 ease-out group-hover:scale-[1.04] group-hover:ring-[var(--accent)] group-hover:shadow-[0_6px_18px_var(--accent-glow)]"
            />
          </button>
        </li>
      ))}
    </ul>
  );
}
